<template>
  <f7-page class="main-volcarmercanciaunidadlogistica">
    <f7-navbar :style="appTheme">
      <f7-nav-left>
        <f7-link
          back
          @click="ExitVolcado"
        >
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
        {{ $t('common.dumping') }}
      </f7-nav-left>
      <f7-nav-right class="padding-right">
        <img
          alt="iconSetting"
          src="@/static/icons/setting.svg"
          @click="abrirConfiguracionTA"
        >
      </f7-nav-right>
    </f7-navbar>

    <div class="content-title-volcado padding-horizontal padding-bottom-half">
      {{ $t('production.dump.home.subtitle') }}
    </div>

    <div class="content-info-volcado padding-horizontal">
      {{ $t('production.dump.home.helpText') }}
    </div>

    <div class="content-inputs-volcado padding">
      <!-- <UCProductionLines
        :valor-por-defecto="linea"
        :mostrar-titulo="false"
      /> -->
      <UCSearchEntityERP
        :placeholder="$t('common.productionLine')"
        :search-text="$t('searchEntity.line.searchText')"
        :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
        :default-value="linea"
        :default-etities-list="lineasProduccion"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        :min-text-search="0"
        :next-and-previous-buttons-shown="false"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventLineaDeProduccionSelected"
      />

      <UCSearchEntityERP
        class="margin-top-half"
        :placeholder="$t('searchEntity.dumpPoint.placeholder.dumpPoint')"
        :search-text="$t('searchEntity.dumpPoint.searchText')"
        :search-cancellation-text="$t('searchEntity.dumpPoint.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.dumpPoint.searchNotFoundText')"
        :default-value="punto"
        :default-etities-list="puntosVolcado"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        :disabled="linea == null"
        :qr-search-show="true"
        @selection="EventPuntoDeVolcadoSelected"
      />
      <PCBuscadorLineasPedidoVenta

        class="margin-top-half"
        @selected="LineasPedidoVentaSeleccionadas"
      />
      <template v-if="punto">
        <PCBuscadorLineasPedidoVenta
          v-if="punto.AsociarLineaPedido"
          class="margin-top-half"
          @selected="LineasPedidoVentaSeleccionadas"
        />

        <PCBuscadorSalidasProduccion
          v-if="punto.PermitirAsignarElementoProduccionAPP"
          class="margin-top-half"
          :punto="punto"
          @selected="SalidasProduccionSeleccionadas"
        />
      </template>
    </div>

    <f7-row class="content-buttons-volcado padding-horizontal">
      <f7-col width="50">
        <f7-button
          id="btn-botonesDeVolcadoYRecuperado-volcar"
          fill
          large
          class="button-volcado"
          @click="volcarMercancia"
        >
          {{ $t('common.dump') }}
        </f7-button>
      </f7-col>
      <f7-col width="50">
        <f7-button
          id="btn-botonesDeVolcadoYRecuperado-recuperar"
          fill
          large
          class="button-recuperar"
          @click="abirMercanciaVolcada"
        >
          {{ $t('common.retrieve') }}
        </f7-button>
      </f7-col>
    </f7-row>
    <!-- Popup Configuración de Volcado -->
    <f7-popup
      class="configuracionVolcado-popup"
      :opened="popupConfiguracionVolcadoAbierto"
      @popup:closed="cerrarConfiguracionTA"
    >
      <FrmDumpMerchandiseConfigurationVue :activo="popupConfiguracionVolcadoAbierto" />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCBuscadorLineasPedidoVenta from '@/components/production/traceability/PCBuscadorLineasPedidoVenta.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCBuscadorSalidasProduccion from '@/components/production/traceability/PCBuscadorSalidasProduccion.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import FrmDumpMerchandiseConfigurationVue from './FrmDumpMerchandiseConfiguration.vue';

export default {
  name: 'FrmDumpMerchandiseLogisticUnitHome',
  components: {
    UCSearchEntityERP,
    FrmDumpMerchandiseConfigurationVue,
    PCBuscadorLineasPedidoVenta,
    PCBuscadorSalidasProduccion,
  },
  data() {
    return {
      linea: null, // Linea seleccionada.
      punto: null, // Punto Seleccionado.
      popupVolcarMecanciaAbierto: false, // Establece si el popup de volvado mercacia esta abierto
      // Establece si el popup de configuracion se encuentra abierto.
      popupConfiguracionVolcadoAbierto: false,
      // Establece si el popup de recuperado de mercancia esta bierto.
      popupRecuperarMercanciaAbierto: false,
      // Cuando esta establecida, no se muestra el componente de busqueda de lineas.
      lineaPorDefecto: null,
      // Cuando esta establecida, no se muestra el componente de busqueda de puntos.
      puntoPorDefecto: null,

      salidasProduccion: [],
      lineasProduccion: null,
      puntosVolcado: null,
      lineaEstablecidaPorDefecto: useSettingRef('Volcado.LineaProduccionEstablecidaPorDefecto'),
      puntoEstablecidoPorDefecto: useSettingRef('Volcado.PuntoVolcadoEstablecidoPorDefecto'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'getLineasProduccion',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'lineaSeleccionadaEnVolcado',
      'lineaDeProduccionSeleccionada',
      'puntoDeVolcadoSeleccionado',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  created() {
    this.activarListener();
  },
  mounted() {
    this.StartComponent();
  },
  unmounted() {
    this.CloseForm();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.comprobarConfiguracionPorDefecto();
      this.lineasProduccion = this.getLineasProduccion;
      if (this.linea != null) {
        this.puntosVolcado = this.linea.PuntosDeVolcado;
      }
    },
    CloseForm() {
      Log(this, this.CloseForm.name);
      if (this.punto !== null) {
        this.punto.LineasPedidoVentaAsociadas = null;

        this.puntoDeVolcadoSeleccionado = this.punto; // Variable Comun
      }
      this.punto = null;
      this.linea = null;
    },
    activarListener() {
      Log(this, this.activarListener.name);
      eventBus.on('configuracionVolcadoMercanciaActualizada', (configuracion) => {
        this.actualizarConfiguracionPuntoVolcado(configuracion);
      });
    },
    EventPuntoDeVolcadoSelected(obj) {
      Log(this, this.EventPuntoDeVolcadoSelected.name);
      if (obj != null) {
        this.establecerPuntoDeVolcadoSeleccionado(obj);
      } else {
        this.punto = null;
      }
    },
    ExitVolcado() {
      Log(this, this.ExitVolcado.name);

      this.lineaSeleccionadaEnVolcado = null;
    },
    EventLineaDeProduccionSelected(obj) {
      Log(this, this.EventLineaDeProduccionSelected.name);
      if (obj != null) {
        this.establecerLineaProduccionSeleccionada(obj);
        this.lineaSeleccionadaEnVolcado = obj;
      } else {
        /* this.lineaSeleccionadaEnVolcado = null; */
        this.lineaDeProduccionNoEstablecida();
      }
    },

    establecerLineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.establecerLineaProduccionSeleccionada.name);
      const self = this;
      self.linea = lineaSeleccionada;
      if (lineaSeleccionada.PuntosDeVolcado != null) {
        this.puntosVolcado = lineaSeleccionada.PuntosDeVolcado;
      }

      if (lineaSeleccionada.PuntosDeVolcado != null && lineaSeleccionada.PuntosDeVolcado.length === 1) {
        [self.punto] = lineaSeleccionada.PuntosDeVolcado;
        this.puntosVolcado = lineaSeleccionada.PuntosDeVolcado;
      }
    },

    establecerPuntoDeVolcadoSeleccionado(puntoSelecionado) {
      Log(this, this.establecerPuntoDeVolcadoSeleccionado.name);
      const self = this;
      self.punto = puntoSelecionado;

      if (self.punto.LineaProduccion != null) {
        self.linea = self.punto.LineaProduccion;
      }
    },

    actualizarConfiguracionPuntoVolcado() {
      Log(this, this.actualizarConfiguracionPuntoVolcado.name);
      const self = this;
      self.popupConfiguracionVolcadoAbierto = false;
      self.linea = this.lineaEstablecidaPorDefecto;
      self.punto = this.puntoEstablecidoPorDefecto;
      self.lineaPorDefecto = this.lineaEstablecidaPorDefecto;
      self.puntoPorDefecto = this.puntoEstablecidoPorDefecto;
    },

    abirMercanciaVolcada() {
      Log(this, this.abirMercanciaVolcada.name);
      this.lineaDeProduccionSeleccionada = this.linea; // Variable Comun

      this.puntoDeVolcadoSeleccionado = this.punto; // Variable Comun
      if (this.punto == null) {
        this.generarNoticacion(this.$t('production.dump.home.buttons.dump.validation.requiredDumpPoint'));
        return;
      }
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandise');
    },

    cerrarMercanciaVolcada() {
      Log(this, this.cerrarMercanciaVolcada.name);
      this.popupRecuperarMercanciaAbierto = false;
    },

    abrirConfiguracionTA() {
      Log(this, this.abrirConfiguracionTA.name);
      this.popupConfiguracionVolcadoAbierto = true;
    },

    cerrarConfiguracionTA() {
      Log(this, this.cerrarConfiguracionTA.name);
      this.popupConfiguracionVolcadoAbierto = false;
      // Esperamos que los listener del frmConfiguración esten eliminados.
      sleep(600).then(() => {
        this.activarListener();
      });
    },

    volcarMercancia() {
      Log(this, this.volcarMercancia.name);

      if (this.punto == null || this.linea == null) {
        this.generarNoticacion(this.$t('production.dump.home.buttons.dump.validation.requiredDumpPoint'));
        return;
      }
      this.popupVolcarMecanciaAbierto = true;
      this.lineaDeProduccionSeleccionada = this.linea; // Variable Comun

      this.puntoDeVolcadoSeleccionado = this.punto; // Variable Comun
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/dump/FrmReadingDumpMerchandiseLogisticUnit', {
        props: {
          salidasProduccion: this.salidasProduccion,
        },
      });
    },

    lineaDeProduccionNoEstablecida() {
      Log(this, this.lineaDeProduccionNoEstablecida.name);
      const self = this;
      if (this.punto !== null) {
        this.punto.LineasPedidoVentaAsociadas = null;

        this.puntoDeVolcadoSeleccionado = this.punto; // Variable Comun
      }
      self.punto = null;
      self.linea = null;
    },

    comprobarConfiguracionPorDefecto() {
      Log(this, this.comprobarConfiguracionPorDefecto.name);
      if (this.lineaSeleccionadaEnVolcado != null) {
        this.lineaPorDefecto = this.lineaSeleccionadaEnVolcado;
        this.linea = this.lineaPorDefecto;
        this.establecerLineaProduccionSeleccionada(this.lineaSeleccionadaEnVolcado);
      } else {
        if (this.lineaEstablecidaPorDefecto != null) {
          this.lineaPorDefecto = this.lineaEstablecidaPorDefecto;
          this.linea = this.lineaPorDefecto;
        }
        if (this.puntoEstablecidoPorDefecto != null) {
          this.puntoPorDefecto = this.puntoEstablecidoPorDefecto;
          this.punto = this.puntoPorDefecto;
        }
      }

      // sleep(600).then(() => { // Esperamos que la ruta actual este activa.
      //   // Si hay una configuración de punto y linea directamenta abrimos lecturas:
      //   if (this.puntoPorDefecto != null
      //     && this.lineaPorDefecto != null
      //     && (f7.views.main.router.currentRoute.path === '/'
      //       || f7.views.main.router.currentRoute.path === '/production/traceability/dumpAndRecoverMerchandise/FrmDumpMerchandiseLogisticUnitHome'
      //     )
      //   ) {
      //     this.volcarMercancia();
      //   }
      // });
    },

    eliminarLinaPorDefecto() {
      Log(this, this.eliminarLinaPorDefecto.name);
      this.lineaPorDefecto = null;
      this.puntoPorDefecto = null; // Si eliminas la linea se elimina el punto tambien.
      this.punto = null;
      this.linea = null;
    },
    eliminarPuntoPorDefecto() {
      Log(this, this.eliminarPuntoPorDefecto.name);
      this.puntoPorDefecto = null;
      this.punto = null;
    },
    generarNoticacion(mensaje) {
      Log(this, this.generarNoticacion.name);
      HiNotification.Toast(mensaje, 4000);
    },
    LineasPedidoVentaSeleccionadas(lstLineasPedido) {
      Log(this, this.LineasPedidoVentaSeleccionadas.name);

      this.punto.LineasPedidoVentaAsociadas = lstLineasPedido;
    },
    SalidasProduccionSeleccionadas(lstSalidasProduccion) {
      Log(this, this.LineasPedidoVentaSeleccionadas.name);
      this.salidasProduccion = lstSalidasProduccion;
    },

    /* puntos de volcado */
    obtenerPuntosDeVolcadoPorCodigo(params) {
      Log(this, this.obtenerPuntosDeVolcadoPorCodigo.name);

      return ConexionTA.callObtenerPuntosDeVolcado(params);
    },
    obtenerPuntosDeVolcado() {
      Log(this, this.obtenerPuntosDeVolcado.name);

      return ConexionTA.callObtenerPuntosDeVolcado(this.linea.Id);
    },
  },
};
</script>

<style lang="scss">
.main-volcarmercanciaunidadlogistica {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-button-small-height: 40px;
  --f7-button-large-height: 50px;
  --f7-button-large-font-size: 14px;
  //

  .content-title-volcado {
    color: #24253d;
    font-size: 28px;
    font-weight: 400;
    padding-top: var(--f7-typography-padding);
    border-bottom: 1px solid var(--his-disabled);
    background-color: var(--his-tierra-white);
  }

  .content-info-volcado {
    color: var(--his-ash-gray);
    padding-top: var(--f7-typography-padding);
    font-size: 14px;
    font-weight: 400;
  }

  .content-inputs-volcado {
    --f7-grid-gap: 8px;

    .div-contenidoComponente {
      .div-botonCodigoQR {
        margin: 0;
        height: 56px;
        min-height: 0;
      }
    }
  }

  .content-buttons-volcado {
    --f7-grid-gap: 8px;

    .button-recuperar {
      background-color: var(--his-orange);
    }

    .button-volcado {
      background-color: #000;
    }
  }
}
</style>
